/* tslint:disable */
/* eslint-disable */
/**
 * Seccl API Documentation
 * #### Welcome to Seccl\'s API reference Hello and welcome! 👋 In this section, we\'ll cover  Our API is organised around REST (Representational State Transfer), which is a particular software architectural style. You can read [more about REST here](https://en.wikipedia.org/wiki/Representational_state_transfer).  Our API uses predictable resource-oriented URLs, accepts form-encoded request bodies and returns JSON-encoded responses. It also uses standard HTTP response codes, authentication and verbs.  You can use the Seccl API in test mode, which doesn\'t affect your live data or interact with other partners. The API route you use determines whether the request is in live mode or test mode. 
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://}".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: AxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}
